<template>
    <Line
        :chart-id="getID"
        :chart-options="JsChartOptions1"
        :chart-data="getDataSet"
        :height=getHeight
    />
</template>

<script>
import {Bar, Line, Pie} from "vue-chartjs";

export default {
    name: "LineChartBox",
    components: {
        Bar,
        Pie,
        Line,
    },
    props: {
        getDataSet: '',
        getID: '',
        getHeight: '',
    },
    data(){
        return {
            JsChartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
            },
        }
    }

}
</script>

<style scoped>

</style>
